import { AnimationEvent } from '@angular/animations';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { OverlayAnimations, ToggleContentAnimations } from './overlay.animations';
import { ActionModalComponent } from '../action-modal/action-modal.component';
import { ActionModalButton } from '../action-modal/action-modal.interface';

@Component({
    selector: 'mapp-editor-overlay',
    templateUrl: './editor-overlay.component.html',
    styleUrls: ['./editor-overlay.component.scss'],
    animations: [OverlayAnimations, ToggleContentAnimations],
    standalone: false,
})
export class EditorOverlayComponent implements OnInit {
    @Input() title: string;

    @Input() topOffsetPx: number;

    @Input() disablePrimaryButton: boolean;

    @Input() processing: boolean;

    @Output() primaryAction: EventEmitter<void> = new EventEmitter();

    @Output() secondaryAction: EventEmitter<void> = new EventEmitter();

    @ViewChild('cancelModal') cancelModal: ActionModalComponent;

    show: boolean;

    styles: string;

    contentStyles: string;

    private readonly footerHeightPx = 73;

    isOpened: boolean;

    cancelModalPrimaryButton: ActionModalButton = {
        label: 'Continue editing',
        action: () => {
            this.cancelModal.close();
        },
    };

    cancelModalSecondaryButton: ActionModalButton = {
        label: 'Leave editing',
        action: () => {
            this.handleCancel();
            this.cancelModal.close();
        },
    };

    /**
     *
     */
    ngOnInit(): void {
        if (this.topOffsetPx) {
            this.styles = `top: ${this.topOffsetPx}px;`;
            this.contentStyles = `height: calc(100% - ${this.topOffsetPx + this.footerHeightPx}px;`;
        }
    }

    /**
     *
     */
    open() {
        this.isOpened = true;
        this.show = true;
    }

    /**
     *
     */
    close() {
        this.show = false;
    }

    /**
     *
     */
    handleClose() {
        this.close();
    }

    /**
     *
     */
    handleCancel() {
        this.close();
        this.secondaryAction.emit();
    }

    /**
     *
     */
    handleSave() {
        this.primaryAction.emit();
    }

    /**
     *
     * @param event
     */
    animationDone(event: AnimationEvent) {
        if (event.toState === 'closed') {
            this.isOpened = false;
        }
    }

    /**
     *
     */
    openCancelModal() {
        if (this.disablePrimaryButton) {
            this.handleCancel();
        } else {
            this.cancelModal.open();
        }
    }
}
